/**
 * Loại log
 */
export default {
  /**
   * Bắt đầu thực hiện
   */
  Begin: 0,

  /**
   * Log của chứng từ
   */
  VoucherLog: 1,

  /**
   * Kết thúc
   */
  End: 2,

  /**
   * Lỗi khác
   */
  ErrorOther: 3,

  /**
   * Khác
   */
  Other: 4,
};
